import { render, staticRenderFns } from "./BusDataSyncDocDetailSetModal.vue?vue&type=template&id=4b8e3237&"
import script from "./BusDataSyncDocDetailSetModal.vue?vue&type=script&lang=js&"
export * from "./BusDataSyncDocDetailSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports